import styled from "styled-components";

const FnrPolygon = styled("polygon")`
  stroke-width: 0px;
  fill: ${({ $virtue, $color, theme: { palette, colors } }) =>
    palette.icon[$virtue] || palette[$color] || colors[$color] || $color};
`;

export default FnrPolygon;
